import { LAYER_TYPE, DEFAULT_LAYER_Z_INDEX } from '@tmapy/config';
import { ensureArray } from '@tmapy/utils';
let idGen = 1;
export const deriveLayerSwitcherStateFromCapabilities = (layer, idPrefix, addedLayers) => {
    if (layer.Layer) {
        const layers = ensureArray(layer.Layer);
        const children = layers.map((item) => deriveLayerSwitcherStateFromCapabilities(item, idPrefix, addedLayers));
        return {
            groupId: `${idPrefix}.${idGen++}`,
            label: layer.Title ?? layer.Name ?? 'UNTITLED GROUP',
            children,
            isExpanded: false,
            isVisible: true,
        };
    }
    else {
        if (!layer.Name) {
            console.warn('LayerSwitcher - The external layer is unnamed');
        }
        const layerId = `${idPrefix}.${layer.Name}`;
        const label = layer.Title ?? layer.Name ?? 'UNTITLED LAYER';
        addedLayers.push({
            id: layerId,
            type: LAYER_TYPE.IMAGE_WMS,
            label,
            sourceOptions: {
                url: '',
                params: {
                    LAYERS: layer.Name,
                },
            },
            layerOptions: {
                visible: false,
                opacity: 1,
                zIndex: DEFAULT_LAYER_Z_INDEX,
            },
        });
        return {
            layerId,
            label,
            isVisible: true,
        };
    }
};
//# sourceMappingURL=deriveLayerSwitcherStateFromCapabilities.js.map